module.exports = __webpack_public_path__ + "img/icon-package-active.bc1fc0a8.svg";